export type CompletionStatusT = 'unstarted' | 'started' | 'completed'

export const CompletionStatuses = {
  unstarted: 'unstarted' as CompletionStatusT,
  started: 'started' as CompletionStatusT,
  completed: 'completed' as CompletionStatusT,

  all(): Array<CompletionStatusT> {
    return [CompletionStatuses.unstarted, CompletionStatuses.started, CompletionStatuses.completed]
  },

  parse(text: string): CompletionStatusT | undefined {
    return CompletionStatuses.all().find(value => value === text)
  },
}

export function isComplete(status: CompletionStatusT): boolean {
  return status === CompletionStatuses.completed
}
